import { createStore, createHook } from 'react-sweet-state';
import { COLLAB_KEY } from '../enums/generalEnums';

const Store = createStore({
  initialState: {
    creatorFilters: {},
    loaderState: false,
    loggedIndUserDetails: {},
    permissions: [],
    userPreference: {},
    notificationsCount: 0,
    inProgressIds: [],
    searchValue: '',
    topTag: '',
    popularTag: COLLAB_KEY,
    showDownloadPopUp: true,
    signUpDialogState: false,
    referrer: null,
    loginDialogState: false,
    userIds: [],
  },
  actions: {
    hasPermission: (permission) => ({ getState }) => {
      return getState().permissions.includes(permission);
    },
    setCreatorFilters: (filter) => ({ setState }) => (
      setState({
        creatorFilters: filter
      })
    ),
    setLoggedIndUserDetails: (details) => ({ setState }) => (
      setState({
        loggedIndUserDetails: details
      })
    ),
    setPermissions: (permission) => ({ setState }) => {
      setState({
        permissions: permission,
      });
    },
    setUserPreference: (preference) => ({ setState }) => (
      setState({
        userPreference: preference
      })
    ),
    setNotificationsCount: (count) => ({ setState }) => (
      setState({
        notificationsCount: count
      })
    ),
    setSearchValue: (search) => ({ setState }) => (
      setState({
        searchValue: search
      })
    ),
    setTopTag: (tag) => ({ setState }) => (
      setState({
        topTag: tag
      })
    ),
    setPopularTag: (tag) => ({ setState }) => (
      setState({
        popularTag: tag
      })
    ),
    setShowDownloadPopUp: (show) => ({ setState }) => (
      setState({
        showDownloadPopUp: show
      })
    ),
    decreaseNotificationCount: () => ({ setState, getState }) => {
      const { notificationsCount } = getState();
      setState({ notificationsCount: notificationsCount - 1 });
    },
    openLoader: (id) => ({ setState, getState }) => {
      setState({ loaderState: true });
      if (id) {
        const { inProgressIds } = getState();
        setState({ inProgressIds: [...inProgressIds, id] });
      }
    },
    closeLoader: (id) => ({ setState, getState }) => {
      setState({ loaderState: false });
      if (id) {
        const { inProgressIds } = getState();
        setState({ inProgressIds: inProgressIds?.filter(item => item !== id) });
      }
    },
    clearStore: () => ({ setState }) => {
      setState({
        userPreference: {},
        permissions: [],
        loggedIndUserDetails: []
      });
    },
    setSignUpDialogState: (status) => ({ setState }) => (
      setState({
        signUpDialogState: status
      })
    ),
    setReferrer: (name) => ({ setState }) => (
      setState({
        referrer: name
      })
    ),
    setLoginDialogState: (status) => ({ setState }) => (
      setState({
        loginDialogState: status
      })
    ),
    setUserIds: (ids) => ({ setState }) => (
      setState({
        userIds: ids
      })
    ),
  }
});

const useStore = createHook(Store);

export default useStore;